<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Search results</h1>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <ul class="list-group list-group-flush">
                <li v-for="r in results" class="list-group-item">
                    <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">
                            <i v-if="r.Type=='User'" class="fa fa-user" aria-hidden="true"></i>
                            <i v-else-if="r.Type=='Workspace'" class="fa fa-folder" aria-hidden="true"></i>
                            <i v-else-if="r.Type=='Portfolio'" class="fa fa-book" aria-hidden="true"></i>

                            <a v-if="r.Url" :href="r.Url" target="_blank">{{r.Type}} {{r.Title}}</a>
                            <span v-else>{{r.Type}} {{r.Title}}</span>
                        </h5>
                        <div>
                            <a v-if="r.AdminUrl" :href="r.AdminUrl" target="_blank">
                                <span>Manage</span>
                                <!--<i class="fa fa-cogs" aria-hidden="true"></i>-->
                            </a>
                        </div>
                    </div>
                    <small>{{r.Details}}</small>
                </li>
            </ul>
            <br />
        </div>
    </div>
</template>

<script lang="ts">
    import Component, { mixins } from 'vue-class-component';
    import PageBase from "@common/PageBase";
    import Queries from "@Organizations/OrganizationUnits/Domain/queries-vue-component";

    @Component
    export default class SearchOrganizationPage extends mixins(PageBase, Queries) {
        get searchPhrase() { return this.$route.params.searchPhrase; }

        get searchOrganizationUnitResultsModel() { return this.model?.SearchOrganizationUnitResults; }
        get results() { return this.searchOrganizationUnitResultsModel?.Results || []; }

        mounted() {
            this.setTitle('Search results');
            this.runSearchOrganizationUnitQueryV1(this.tid, this.searchPhrase);
        }
    }
</script>

<style scoped>
</style>